var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecoverLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.75128,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.497431
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1727 3.89346L10.2329 2.83325H6.52913V6.53702L7.59397 5.47219C8.50602 6.14813 9.09863 7.22222 9.09863 8.44447C9.09863 9.05096 8.95048 9.62041 8.69121 10.1251C9.76993 9.42134 10.4875 8.20835 10.4875 6.82407C10.4875 5.65738 9.97364 4.61569 9.1727 3.89346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1727 3.89346L10.2329 2.83325H6.52913V6.53702L7.59397 5.47219C8.50602 6.14813 9.09863 7.22222 9.09863 8.44447C9.09863 9.05096 8.95048 9.62041 8.69121 10.1251C9.76993 9.42134 10.4875 8.20835 10.4875 6.82407C10.4875 5.65738 9.97364 4.61569 9.1727 3.89346Z",
    fill: "#EB6E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88908 5.55534C4.88908 4.94885 5.03723 4.37939 5.29649 3.87476C4.21314 4.57847 3.50016 5.79146 3.50016 7.17574C3.50016 8.34243 4.00943 9.38412 4.815 10.1064L3.75017 11.1666H7.45394V7.46279L6.3891 8.52762C5.48168 7.85168 4.88908 6.77759 4.88908 5.55534Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88908 5.55534C4.88908 4.94885 5.03723 4.37939 5.29649 3.87476C4.21314 4.57847 3.50016 5.79146 3.50016 7.17574C3.50016 8.34243 4.00943 9.38412 4.815 10.1064L3.75017 11.1666H7.45394V7.46279L6.3891 8.52762C5.48168 7.85168 4.88908 6.77759 4.88908 5.55534Z",
    fill: "#EB6E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverLogo);
export default __webpack_public_path__ + "static/media/recoverLogo.97f90edd77b6849e0aaf309b4a4f5608.svg";
export { ForwardRef as ReactComponent };